import React, { useState } from "react";
import "./styles.css";
import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
//import { NavLink } from "react-router-dom";
import SideNav from './../../../components/SideNav_PS';
import Grid from '@material-ui/core/Grid';
import DisplayPerfilPs from './../../../components/Display_ProfissionalSaude/Perfil_PS';

export default function RI_Login() {
    let [search, setSearch] = useState(false);
    //let [login, setLogin] = useState(false);
    
    return (
        <>
        <SideNav />
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
           
                <Collapse isOpened={search}>
                    <input id="Tela_PS" type="text" placeholder="pesquisa..." />
                </Collapse>
                <AiOutlineSearch
                    size={"6vh"}
                    onClick={() =>
                        setSearch(!search)
                    }
                    id="Icon-Search-PS"
                />
        </Grid>
        </div>

        <div id="main-PS-Login">
             <DisplayPerfilPs />   
        </div>

        </>
    );
    
}